import { TabataExercise } from './TabataExercise';
import { Tabata } from './Tabata';
import {
  DndList,
  DnDParentRenderer,
  getChildDnDProps,
  getParentDnDProps,
} from '@design-system/components/dndList/DndList';
import { PropsWithChildren } from 'react';
import { _noop } from '@client/new/helpers/general';
import { WorkoutVM } from '../../view-model/workout.viewModel';
import { HIIT } from './HIIT';
import { HIITExercise } from './HIITExercise';
import { Exercise } from '../../view-model/workouts.domain';
import { F1, TMap } from '@client/new/helpers/types';
import { isParentExercise } from '../../view-model/workout.mappers';
import { workoutVM } from '@client/new/pages/workout/WorkoutEdit';

export const Workout = (p: { vm?: WorkoutVM; exerciseIds?: Array<string> }) => {
  const vm = workoutVM.useValue();
  const items = p.exerciseIds
    ? vm.exerciseIds.filter((e) => (p.exerciseIds || []).includes(e.id))
    : vm.exerciseIds;

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <DndList
        items={items}
        onChange={(d) => vm.dispatch('reorder', d)}
        renderParent={ExerciseRenderer}
        renderChild={ExerciseRenderer}
      />
    </div>
  );
};

export type ExerciseRendererProps = PropsWithChildren<{ id: string }>;
export type ExerciseRenderer = F1<ExerciseRendererProps, JSX.Element>;

const exerciseRenderers: TMap<Exercise['type'], ExerciseRenderer> = {
  HIIT,
  Tabata,
  TabataExercise,
  HIITExercise,
};

const ExerciseRenderer: DnDParentRenderer<ExerciseRendererProps> = ({
  provided,
  item: { id },
  children,
}) => {
  const vm = workoutVM.useValue();
  const ex = vm.exerciseMap[id];
  const dndProps = (
    isParentExercise(ex) ? getParentDnDProps : getChildDnDProps
  )(provided);
  return (
    <div {...dndProps} id={id}>
      {exerciseRenderers[ex.type]({ id, children })}
    </div>
  );
};
